import {
  Input,
  UtilityButton,
  FiatCurrency,
  Select,
  useTheme,
  Typography,
} from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useAsyncFn } from 'react-use';
import { createOrder } from 'tabs/api';
import { Order } from 'tabs/types';

export const CreateOrderForm = ({
  onSuccess,
}: {
  onSuccess: (arg1: Order) => void;
}) => {
  const { spacing } = useTheme();
  const [amount, setAmount] = useState<number | null>();
  const [referenceId, setReferenceId] = useState('');
  const currencies: FiatCurrency[] = ['SEK', 'EUR', 'USD', 'NOK'];
  const currencyOptions = currencies.map((currency) => ({
    value: currency,
    label: currency,
  }));
  const [currency, setCurrency] = useState<string>('EUR');
  const disabled = !amount || !currency;

  const [{ loading }, createOrderHandler] = useAsyncFn(async () => {
    if (disabled) {
      return null;
    }
    const orderResponse = await createOrder({
      amount,
      currency: currency,
      referenceId,
    });
    onSuccess(orderResponse);
    return true;
  }, [amount, currency, referenceId]);

  if (loading) {
    return <>Creating Order</>;
  }
  return (
    <div style={{ display: 'grid', gap: spacing.xxs }}>
      <Typography variant="bodySmallest">
        Create a payment order. Reference field is limited to 128 characters and
        is optional.
      </Typography>
      <div style={{ display: 'flex', gap: spacing.xxs }}>
        <Input
          label="Amount"
          type="number"
          value={amount ? amount.toString() : ''}
          onChange={(e) => {
            if (Number(e.target.value) < 0) {
              return;
            }
            setAmount(Number(e.target.value));
          }}
        />
        <Select
          label="Currency"
          multiple={false}
          options={currencyOptions}
          values={[currency]}
          onSelect={(e) => {
            setCurrency(e[0]);
          }}
        />
      </div>

      <Input
        label="Reference"
        type="text"
        value={referenceId}
        onChange={(e) => {
          if (e.target.value.length > 128) {
            return false;
          }
          setReferenceId(e.target.value);
        }}
      />

      <UtilityButton
        disabled={disabled}
        variant="secondary"
        text="Create order"
        onClick={async () => {
          await createOrderHandler();
        }}
      />
    </div>
  );
};
